
export type TGameConfig = {
  MapWidth: number;
  MapHeight: number;
  TileSize: number;
  NumberOfTowns: number;
  MinDistance: number;
  EdgeGap: number;
  ChaserAddInterval: number;
  RandomEncounter: number;
  MinEncounterInterval: number;
  BaseActionCost: number; 
}

/**
 * Configuration object for the game settings, 
 * these are settings that are not expected to change during the game, but we might change during development.
 *
 * @property mapWidth - The width of the game map in tiles.
 * @property mapHeight - The height of the game map in tiles.
 * @property tileSize - The size of each tile in pixels.
 * @property numberOfTowns - The total number of towns to generate on the map.
 * @property minDistance - The minimum distance between towns in tiles.
 * @property edgeGap - The gap between the edge of the map and the nearest town in tiles.
 * @property chaserAddInterval - The interval (in game ticks) at which new chasers are added.
 * @property RandomEncounter - The basic chance of a random encounter occurring every hour.
 * @property MinEncounterInterval - The minimum number of hours that must pass between encounters.
 * @property BaseActionCost - The basic stamina cost for any combat action.
 */
export const gameConfig: TGameConfig = {
  MapWidth: 80,
  MapHeight: 30,
  TileSize: 20,
  NumberOfTowns: 10,
  MinDistance: 10,
  EdgeGap: 4,
  ChaserAddInterval: 100,
  RandomEncounter: 0.05,
  MinEncounterInterval: 7,
  BaseActionCost: 5
}
